import React from "react";
import ReactDOM from "react-dom/client";
import { Chart, registerables } from "chart.js";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "bootstrap/dist/css/bootstrap.min.css";

// Chart.js v4: elementos e escalas precisam ser registrados
Chart.register(...registerables);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
